export default function lineLimiting(lineCount, textExtractor, textSetter) {
  return function limiter(ele) {
    const $ele = $(ele);
    const originalText = typeof textExtractor === 'function' ? textExtractor($ele) : $ele.text();
    const words = originalText.split(' ');
    while (words.length) {
      const nLine = $ele.height() / parseFloat($ele.css('line-height'));
      if (nLine <= lineCount) {
        return;
      }
      words.pop();
      const text = `${words.join(' ')}...`;
      if (typeof textSetter === 'function') {
        textSetter($ele, text);
      } else {
        $ele.text(text);
      }
    }
  };
}
